import CustomerList from "./manageUsers/userList";
import CustomerTopbar from "./manageUsers/topbar";
import OrderManagement from "./orderManagement/order";
import DiscountCoupon from "./DiscountAndCoupon/discountCoupon";
import AddProduct from "./DiscountAndCoupon/add";
import viewDiscount from "./DiscountAndCoupon/view";
import ViewOrder from "./orderManagement/view";
import ViewOrderManagement from "./orderManagement/view";

/* eslint-disable import/no-anonymous-default-export */
export default {
  CustomerTopbar,
  CustomerList,
  OrderManagement,
  DiscountCoupon,
  AddProduct,
  viewDiscount,
  ViewOrder,
  ViewOrderManagement

};
